import { CartViewModel } from "./cart.vm";

export const CartInitialiser = () => {
  ko.applyBindings(new CartViewModel(), document.body);
}